import { Component, inject } from '@angular/core';
import { LdwRouterService } from '../../../route/ldw-router.service';

@Component({
    selector: 'ldw-document-bookmarks-button',
    templateUrl: './document-bookmarks-button.component.html',
    styleUrls: ['./document-bookmarks-button.component.css'],
    standalone: false
})
export class DocumentBookmarksButtonComponent {
  private routerService = inject(LdwRouterService);

  btnClick(e: any) {
    this.routerService.navigateToSearch('1001', true);
  }
}
